import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ACWTimer.module.css';

interface AcwTimerHeaderProps {
  skillName?: string;
  duration: number;
}

export function AcwTimerHeader({ skillName, duration }: AcwTimerHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <h3 className={styles.title}>
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
        </svg>
        {t('acw:timer.title')}
      </h3>
      <p className={styles.subtitle}>{t('acw:timer.subtitle')}</p>
      {skillName && (
        <p className={styles.skillInfo}>
          <span className={styles.skillName}>{skillName}</span>
          <span className={styles.skillAcw}>
            ACW: {Math.floor(duration / 60)}:{(duration % 60).toString().padStart(2, '0')}
          </span>
        </p>
      )}
    </div>
  );
}
